module.exports = __webpack_public_path__ + "img/fish_shrimp.ef32bd7f.png";